import React, { useEffect, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Button, Col, Menu, Row, message } from "antd";
import { host } from "@Services/url";
import { setUrlFormat } from "@Lib/common";
import { updateHistoryRecord } from "@Services/common";
import { EHistoryRecordType } from "@Types/constants";
interface IProps {
  index: number;
  inquiry: string;
  competeListData: any;
  dataSource: {
    [key: string]: any;
  };
  data: {
    brandId?: number;
    brandName?: string;
    equips: IEquips[];
    gas?: number | string;
    isBasic?: number;
    inStock?: number;
    kindId?: number;
    kindName?: string;
    modelId?: number;
    modelName?: string;
    modelYearId?: number;
    newKindId?: number;
    price?: number;
    year?: number;
    isInquiry: number;
    maxDiscountPrice: number;
  };
  onClickCompete: (e) => void;
}
export interface IEquips {
  /**
   * 配备id
   */
  entryId?: number;
  /**
   * 配备标题
   */
  entryName?: string;
  /**
   * 额外数据，如单位
   */
  expand?: string;
  /**
   * 配备的上一层id，如影音配备
   */
  paramId?: number;
  /**
   * 配备上一层名称
   */
  paramName?: string;
  /**
   * 配备值
   */
  value?: string;
}

const Item: React.FC<IProps> = ({ data, dataSource, index, onClickCompete, inquiry, competeListData }) => {
  const [showState, setShowState] = useState(false);
  const [dataPriceNum, setDataPriceNum] = useState(0);
  const [differentListData, setDifferentListData] = useState<IEquips[]>([]);
  const [dataIDsList, setDataIDsList] = useState<any[]>([]);
  const [messageApi, contextHolder] = message.useMessage();

  const setDuplicateData = async (dataArray: any) => {
    const myidArray = dataArray.map((item) => item.myid);
    setDataIDsList(myidArray);
  };

  // 设置历史记录
  const setHistoryRecord = async () => {
    try {
      await updateHistoryRecord({ id: String(data.modelYearId), type: EHistoryRecordType.MODEL });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const nextIndex = index + 1 < dataSource.data.length ? index + 1 : index;
    const nextData = nextIndex < dataSource.data.length ? dataSource.data[nextIndex] : null;

    if (nextData && nextData.equips && nextData.equips.length > 0) {
      setDataPriceNum(data.price ? Number((nextData.price - data.price).toFixed(1)) : 0);

      // 用nextData.equips去data.equips对比，拿出nextData.equips的数据
      const differentTitleData = nextData.equips.filter(
        (item) =>
          !data.equips.some(
            (otherItem) =>
              `${item.entryName}${item.expand}${item.value}` ===
              `${otherItem.entryName}${otherItem.expand}${otherItem.value}`,
          ),
      );

      setDifferentListData(differentTitleData);
    }
  }, [data, dataSource.data, index]);

  useEffect(() => {}, []);

  useEffect(() => {
    setDuplicateData(competeListData);
  }, [competeListData]);

  return (
    <div>
      <Row className='py-20'>
        <Col span={14} className='cursor-pointer flex items-center'>
          <h3 className='text-18 text-[#333333] pl-34'>
            <a
              id='tracking-SummaryModel'
              href={`${host.c}/${setUrlFormat(data.brandName)}/${setUrlFormat(data.kindName)}/Specification.html?bm=${
                data.modelYearId
              }&inStock=${data.inStock}`}
              data-id={data.modelYearId}
              target='_blank'
              className='text-18 text-[#333333] hover:text-[#333]'
              onClick={() => setHistoryRecord()}
            >
              {data.year}年式 {data.modelName} {data.isBasic === 1 && "（基本款）"}
            </a>
          </h3>
        </Col>
        <Col span={10} className='text-14 text-[#3264FF] flex justify-between'>
          <div className='flex items-center justify-between w-full'>
            <p className='text-[#FF3232] mb-0 font-bold text-16 w-80 text-center'>{data.price}萬</p>
            <div id='tracking-AddToPKBtn' className='flex items-center justify-center pr-18'>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  onClickCompete(data);
                }}
              >
                {contextHolder}
                {dataIDsList.length > 0 && dataIDsList.indexOf(data.modelYearId) !== -1 ? (
                  <div
                    id='AddToPKBtn'
                    data-id={data.modelYearId}
                    data-text='取消比較'
                    className='border-1 border-solid border-[#3264FF] flex items-center justify-center h-30 rounded-4 mr-20 cursor-pointer font-medium w-72'
                  >
                    取消比較
                  </div>
                ) : (
                  <div
                    id='AddToPKBtn'
                    data-id={data.modelYearId}
                    data-text='+比較'
                    className='border-1 border-solid border-[#3264FF] flex items-center justify-center h-30 rounded-4 mr-20 cursor-pointer font-medium w-72'
                  >
                    <PlusOutlined style={{ fontSize: "12px" }} />
                    比較
                  </div>
                )}
              </div>

              {!!data.isInquiry && (
                <>
                  <a
                    id='tracking-kindsum-tradeIn'
                    target='_blank'
                    href={`/ask/price?b=${data.brandId}&k=${data.kindId}&myid=${data.modelYearId}&source=綜述頁-車型列表-汰舊換新&kindType=tradeIn`}
                    className='border-1 border-solid border-[#3264FF] flex items-center justify-center h-30 rounded-4 mr-20 cursor-pointer font-medium w-72 text-[#3264FF] text-14 hover:text-[#3264FF]'
                  >
                    汰舊換新
                  </a>
                  <a
                    href={`/ask/price?b=${data.brandId}&k=${data.kindId}&myid=${data.modelYearId}&source=${inquiry}`}
                    target='_blank'
                    className='font-bold text-[#fff] bg-[#3264FF] rounded-4'
                    onClick={() => setHistoryRecord()}
                  >
                    <Button
                      type='primary'
                      style={{
                        width: "72px",
                        height: "30px",
                        padding: "0",
                        borderRadius: "4px",
                        backgroundColor: "#3264FF",
                        borderColor: "#3264FF",
                      }}
                    >
                      詢優惠價
                    </Button>
                  </a>
                </>
              )}
            </div>
          </div>
        </Col>
      </Row>
      {(dataPriceNum !== 0 || !!differentListData.length) && (
        <Row className='bg-[#f2f4f97a] cursor-pointer'>
          <Col span={24}>
            <div
              className='text-14 text-[#999] flex items-center py-10 pl-14'
              id='upgradeSpecification'
              onClick={() => setShowState(!showState)}
            >
              <img className='w-8 h-16' src='https://photo.8891.com.tw/2023/08/30/1693365486953304.png' alt='' />
              <p className='text-[#FF3232] mr-10 ml-8 mb-0'>+{dataPriceNum}萬</p>
              升級下一車型（增加
              <span className='text-[#FF3232]'>{differentListData.length || 0}</span>
              配備）
            </div>

            {showState && Array.isArray(differentListData) && differentListData.length > 0 && (
              <div className='py-20 px-24 w-600 grid grid-cols-2 gap-x-4 gap-y-28'>
                {differentListData.map((item, index) => (
                  <div
                    key={index}
                    className='text-[#666666] text-14 leading-20 flex flex-wrap font-medium white-space-pre'
                  >
                    ·{item.entryName} {`${item.expand !== "" ? `: ${item.expand}` : ""}`}
                  </div>
                ))}
              </div>
            )}
          </Col>
        </Row>
      )}
    </div>
  );
};
export default Item;
